import { Helmet } from "react-helmet-async";

const SITE_URL = "https://pulaar.co";
const DEFAULT_IMAGE = `${SITE_URL}/heritage/pulaar-argentique-fleuve-senegal-bateau.jpg`;

/**
 * SEO — meta tags par page (titre, description, canonical, OG, Twitter).
 * Surcharge les valeurs par défaut posées dans /public/index.html.
 *
 * Props :
 *  - title       : string  — titre de la page (sera suffixé " — Pulaar")
 *  - description : string  — meta description
 *  - path        : string  — chemin canonique (ex: "/archives/maabube")
 *  - image       : string  — URL absolue de l'image OG (par défaut : hero argentique)
 *  - imageAlt    : string  — alt de l'image OG
 *  - type        : string  — og:type (ex: "website", "article", "product")
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  imageAlt = "Pulaar — vestiaire éditorial peul",
  type = "website",
}) {
  const fullTitle = title ? `${title} — Pulaar` : "Pulaar — Vestiaire éditorial";
  const url = `${SITE_URL}${path}`;
  const absImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={absImage} />
      <meta property="og:image:alt" content={imageAlt} />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />
    </Helmet>
  );
}
